import { create } from 'zustand';

const useLoadingStore = create((set) => ({
  loading: false,
  chatListLoading: false,
  chatMessagesLoading: false,
  chatMemebersLoading: false,

  setLoading: (loading) => set({ loading }),
  setChatListLoading: (loading) => set({ chatListLoading: loading }),
  setChatMembersLoading: (loading) => set({ chatMemebersLoading: loading }),
  setChatMessagesLoading: (loading) => set({ chatMessagesLoading: loading }),
}));

export default useLoadingStore;
